import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Line, Text } from "@react-three/drei";
import { distanceBetweenPoints3D } from "../math/util";
import { formatLength } from "../util";
export const DimensionLine = ({ from, to, text, units = 'm', }) => {
    /* ========== CONFIG ========== */
    const tickSize = 0.5; // длина засечек
    const offset = 0.4; // смещение линии вбок
    const textLift = 0.2; // подъём текста над линией
    const fontSize = 0.2;
    /* ========== DIRECTION ========== */
    const dir = [
        to[0] - from[0],
        to[1] - from[1],
        to[2] - from[2],
    ];
    const len = Math.hypot(dir[0], dir[1], dir[2]);
    const nDir = len === 0 ? [0, 0, 0] : [dir[0] / len, dir[1] / len, dir[2] / len];
    /* ========== NORMAL / OFFSET ========== */
    let normal;
    if (Math.abs(nDir[0]) > 0.001 || Math.abs(nDir[2]) > 0.001) {
        // линия не вертикальная → смещение перпендикулярно в XZ
        normal = [nDir[2], 0, nDir[0]];
    }
    else {
        // вертикальная линия → смещаем по X
        normal = [1, 0, 0];
    }
    /* ========== OFFSET LINE & TICKS ========== */
    const lineFrom = [
        from[0] + normal[0] * offset,
        from[1] + normal[1] * offset,
        from[2] + normal[2] * offset,
    ];
    const lineTo = [
        to[0] + normal[0] * offset,
        to[1] + normal[1] * offset,
        to[2] + normal[2] * offset,
    ];
    const leftTick = [
        from,
        [
            from[0] + normal[0] * tickSize,
            from[1] + normal[1] * tickSize,
            from[2] + normal[2] * tickSize,
        ],
    ];
    const rightTick = [
        to,
        [
            to[0] + normal[0] * tickSize,
            to[1] + normal[1] * tickSize,
            to[2] + normal[2] * tickSize,
        ],
    ];
    /* ========== CENTER & TEXT ========== */
    const center = [
        (lineFrom[0] + lineTo[0]) / 2,
        (lineFrom[1] + lineTo[1]) / 2,
        (lineFrom[2] + lineTo[2]) / 2,
    ];
    const label = text ?? formatLength(distanceBetweenPoints3D(from, to), units);
    // поворот текста вдоль линии, но для вертикальных линий оставляем 0
    const angleY = (Math.abs(nDir[0]) < 0.001 && Math.abs(nDir[2]) < 0.001)
        ? 0
        : Math.atan2(nDir[2], nDir[0]);
    const textPos = [
        center[0],
        center[1] + textLift,
        center[2],
    ];
    /* ========== RENDER ========== */
    return (_jsxs("group", { children: [_jsx(Line, { points: leftTick, color: "black", lineWidth: 2 }), _jsx(Line, { points: rightTick, color: "black", lineWidth: 2 }), _jsx(Line, { points: [lineFrom, lineTo], color: "black", lineWidth: 2 }), _jsx(Text, { position: textPos, rotation: [0, angleY, 0], fontSize: fontSize, color: "black", anchorX: "center", anchorY: "middle", children: label })] }));
};
